import { useEffect, useRef, useState } from "react";
import { motion, useInView } from "framer-motion";
import { STATS } from "../../data/content";

function Counter({ value, suffix }) {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-60px" });
  const [display, setDisplay] = useState(0);

  useEffect(() => {
    if (!inView) return;
    let start = 0;
    const duration = 1800;
    const startTime = performance.now();
    const step = (now) => {
      const p = Math.min((now - startTime) / duration, 1);
      const eased = 1 - Math.pow(1 - p, 3);
      setDisplay(Math.floor(eased * value));
      if (p < 1) requestAnimationFrame(step);
      else setDisplay(value);
    };
    requestAnimationFrame(step);
  }, [inView, value]);

  return (
    <span ref={ref} className="font-cinzel text-3xl md:text-4xl font-semibold text-gold-metallic">
      {display}{suffix}
    </span>
  );
}

export default function Stats() {
  return (
    <section data-testid="stats-section" className="relative py-14 md:py-20 overflow-hidden border-y border-white/10">
      <div className="ambient-emerald" style={{ width: 700, height: 300, top: "50%", left: "50%", transform: "translate(-50%,-50%)", opacity: 0.3 }} />
      <div className="relative z-10 mx-auto max-w-7xl px-6 md:px-10 grid grid-cols-2 lg:grid-cols-4 gap-10">
        {STATS.map((s, i) => (
          <motion.div
            key={s.label}
            data-testid={`stat-${i}`}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7, delay: i * 0.1, ease: [0.16, 1, 0.3, 1] }}
            className="text-center"
          >
            <Counter value={s.value} suffix={s.suffix} />
            <p className="font-inter text-[10px] md:text-xs tracking-[0.2em] uppercase text-white/50 mt-3">{s.label}</p>
          </motion.div>
        ))}
      </div>
    </section>
  );
}
